import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Setting } from '@univacity/shared/types';

@Component({
  selector: 'un-view-switch',
  templateUrl: './view-switch.component.html',
  styleUrls: ['./view-switch.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ViewSwitchComponent {
  @Input() display: 'list' | 'grid';
  @Input() storageKey: Setting;
  @Output() displayChange = new EventEmitter<'list' | 'grid'>();
  setDisplay(display: 'grid' | 'list') {
    localStorage.setItem(this.storageKey, display);
    this.displayChange.emit(display);
  }
}
